{
  "verified": "Verified",
  "iv_status": {
    "verified": "Verified",
    "pending": "Pending",
    "attention": "Attention"
  },
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "rotate": "Rotate",
  "close": "Close",
  "dialog": "Dialog",
  "esc_to_close": "Press ESC to close",
  "play": "Play",
  "pause": "Pause",
  "mute": "Mute",
  "unmute": "Unmute",
  "enter_full_screen": "Enter Full Screen",
  "exit_full_screen": "Exit Full Screen",
  "video_not_supported": "Your browser does not support the video tag.",
  "skip_forward": "Skip Forward",
  "skip_backward": "Skip Backward",
  "loading": "Loading",
  "loading_video": "Loading video...",
  "loading_data_description": "Please wait while we load your data. This won't take long.",
  "no_results": "No results",
  "nothing_found": "Nothing found",
  "save_changes": "Save Changes",
  "saved_exclamation": "Saved!",
  "saving": "Saving",
  "validating": "Validating",
  "error": "Error",
  "optional": "Optional",
  "search_property": "Search property",
  "reset_search": "Reset search",
  "no_items_to_show": "No items to show",
  "showing_range_of_total_items": "Showing {{range}} of {{total}} items",
  "rows_per_page": "Rows per page",
  "page_of_pages": "Page {{page}} of {{pages}}",
  "go_to_first_page": "Go to first page",
  "go_to_previous_page": "Go to previous page",
  "go_to_next_page": "Go to next page",
  "go_to_last_page": "Go to last page",
  "sort_in_asc": "Sort in ascending order",
  "sort_in_desc": "Sort in descending order",
  "sort_a_z": "Sort A → Z",
  "sort_z_a": "Sort Z → A",
  "clear_sorting": "Clear sorting",
  "reach_us_at_email": "Reach support at support@chekin.com",
  "please_wait": "Please wait",
  "feature_coming_soon": "Coming soon",
  "feature_coming_soon_description": "This feature is currently in development and will be available soon. Stay tuned for updates!",
  "download_all": "Download All",
  "entry_forms": "Entry forms",
  "tutorial": "Tutorial",
  "liveness_video": "Liveness video",
  "beta": "Beta",
  "reviews": "Reviews",
  "learn_more": "Learn more",
  "this_cannot_be_reverted": "This cannot be reverted",
  "delete": "Delete",
  "cancel": "Cancel",
  "you_have_made_changes": "You have made changes",
  "would_you_like_to_save_them": "Would you like to save them?",
  "save": "Save",
  "dont_save": "Don't save",
  "copied_exclamation": "Copied!",
  "search_placeholder": "Search…",
  "type_to_search": "Type to search…",
  "loading_more": "Loading…",
  "no_options": "No options",
  "select_option": "Select option",
  "clear_all": "Clear all",
  "remove_item": "Remove {{label}}",
  "upload_file": "Upload file",
  "download_attachment": "Download attachment",
  "remove_file": "Remove file",
  "open_calendar": "Open calendar",
  "clear_dates": "Clear dates",
  "clear_date": "Clear date",
  "select_dates": "Select dates",
  "select_date": "Select date",
  "pick_date_range": "Pick a date range",
  "from": "From",
  "to": "To",
  "pick_month": "Pick a month",
  "pick_date": "Pick a date",
  "month": "Month",
  "day": "Day",
  "year": "Year",
  "done": "Done",
  "wrong_period_of_dates": "Selected period is invalid",
  "date_range_max_days_error_one": "Range cannot exceed {{count}} day",
  "date_range_max_days_error_other": "Range cannot exceed {{count}} days",
  "date_range_min_days_error_one": "Range must be at least {{count}} day",
  "date_range_min_days_error_other": "Range must be at least {{count}} days",
  "past_dates": "Date cannot be before {{minDate}}",
  "future_dates": "Date cannot be after {{maxDate}}",
  "year_out_of_range": "Year must be between {{min}} and {{max}}",
  "signature_placeholder_text": "Sign inside this box.<br/> Use your finger.<br/> Tap to start.",
  "open_devices_camera": "Open device's camera",
  "place_document_inside_frame": "Place your document inside the frame",
  "close_other_application_that_may_be_using_your_camera": "Close other applications that may be using your camera",
  "if_you_use_external_camera_disconnect_and_reconnect": "If you use an external camera, disconnect and reconnect it",
  "close_the_browser_re_open_it": "Close the browser and reopen it",
  "camera_errors": {
    "experiencing_camera_issues": "Experiencing camera issues?",
    "chekin_cant_use_your_camera": "Chekin can't use your camera",
    "please_try_a_different_browser": "Your camera doesn't work in this browser. Please, try to open the link in a different browser.",
    "permissions_denied": "Permission denied",
    "camera_permissions_denied": "The camera doesn't open? Make sure to allow the browser permission to use the camera.",
    "no_camera_device_found": "No camera device found. Please connect a camera.",
    "constraints_camera_error": "Constraints cannot be satisfied by available devices.",
    "safari_camera_error": "Safari could not satisfy the camera requirements",
    "try_chrome_or_firefox": "Please try Chrome or Firefox"
  },
  "clear": "Clear",
  "show_less": "Show less",
  "show_more": "Show more",
  "tap_here_to_sign": "Tap here to sign",
  "click_here_to_sign": "Click here to sign",
  "prefix": "Prefix",
  "prefix_required": "Prefix is required",
  "reset": "Reset",
  "show_password": "Show password",
  "hide_password": "Hide password",
  "increment": "Increment",
  "decrement": "Decrement",
  "create_option": "Create \"{{input}}\""
}
